import { CheckCircleIcon } from "@heroicons/react/24/solid";
import classNames from "classnames";
import { theming } from "./theming";
import { Props } from "./Shape";

export function BottomText(props: Props) {
  if (props.type !== "icon") {
    return null;
  }

  const {
    text,
    textSize = "normal",
    textOverflowBehavior = "ellipsis",
    theme,
    active,
  } = props;

  if (!text?.trim()) {
    return null;
  }

  return (
    <div
      className={classNames(
        "overflow-hidden text-center font-brik transition-colors",
        textOverflowBehavior === "ellipsis" &&
          "text-ellipsis whitespace-nowrap",
        textSize === "normal" ? "mt-2 text-base" : "mt-0.5 text-xs",
        active == true && theme !== "transparent"
          ? theming[theme].outline.textActive
          : "text-white"
      )}
    >
      {active === true ? (
        <span className="overflow-hidden text-ellipsis whitespace-nowrap text-center">
          <CheckCircleIcon className="mr-1 inline-block h-4 w-4" />
          Selected
        </span>
      ) : (
        text
      )}
    </div>
  );
}
